import { BaseDestinationJobFilterHandler } from '../destination-job-filter';

export class PracticeIdFilter<
  JobData extends object,
> extends BaseDestinationJobFilterHandler<JobData> {
  key = 'practiceId';
  label = 'Practice Id';
  description = 'Source Id for the practice';
}
